var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome100Client(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.12766 22.8723H7.44681V14.0071H15.2482V22.8723H20.5674V9.04255L11.3475 2.12766L2.12766 9.04255V22.8723ZM2.12766 25C1.54255 25 1.04167 24.7917 0.625 24.375C0.208333 23.9583 0 23.4574 0 22.8723V9.04255C0 8.70567 0.0753546 8.38653 0.226064 8.08511C0.376773 7.78369 0.585106 7.53546 0.851064 7.34043L10.0709 0.425532C10.267 0.283688 10.472 0.177305 10.686 0.106383C10.8999 0.035461 11.1227 0 11.3545 0C11.5863 0 11.8075 0.035461 12.0182 0.106383C12.229 0.177305 12.4309 0.283688 12.6241 0.425532L21.844 7.34043C22.1099 7.53546 22.3183 7.78369 22.469 8.08511C22.6197 8.38653 22.695 8.70567 22.695 9.04255V22.8723C22.695 23.4574 22.4867 23.9583 22.07 24.375C21.6534 24.7917 21.1525 25 20.5674 25H13.1206V16.1348H9.57447V25H2.12766Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome100Client);
export default __webpack_public_path__ + "static/media/home100client.96a3f9a29c99b24cdec0ed50e76670e6.svg";
export { ForwardRef as ReactComponent };